import {useContext, useEffect, useState} from "react";
import {
    Image,
    ImageWrapper,
    PageTitle,
    PageWrapper,
    Row,
    SheetWrapper,
    TextCard,
    TextLine,
    TextLines
} from "./content.style";
import {LanguageContext} from "../../contexts/language.context";

const SPREADSHEET_ID = process.env.REACT_APP_SPREADSHEET_ID;
const API_KEY = process.env.REACT_APP_API_KEY;
const noImage = process.env.REACT_APP_NO_IMAGE;

// ** ** for title to be Bold ex: **Desert cu arahide: ** ...


const normalizeImageUrl = (value) => {
    if (!value) return "";
    const match = value.match(/"(https?:\/\/[^"]+)"/);
    return match ? match[1] : value;
};

const isValidImageUrl = (value) => {
    if (!value) return false;
    const v = value.trim();
    // accept http(s) links and data URLs (base64 images)
    return /^(https?:\/\/|data:image\/[a-zA-Z]+(?:\+xml)?;base64,)/.test(v);
};

const hasImageCandidate = (value) => {
    return !!(value && String(value).trim() !== "");
};

const parseLine = (line) => {
    if (line.startsWith("**") && line.endsWith("**")) {
        return <h3 className="text-xl font-bold">{line.replace(/\*\*/g, "")}</h3>;
    }

    if (line.startsWith("- ")) {
        return <li>{line.slice(2)}</li>;
    }

    return line;
};

const Content = () => {
    const [sheetsData, setSheetsData] = useState([]);

    const { romanianLanguage } = useContext(LanguageContext);

    const numberOfColumnTxt = romanianLanguage ? 1 : 2


    useEffect(() => {
        const fetchSheetData = async () => {
            const SHEET_NAME = "Лист1"; // numele sheet-ului dorit

            const response = await fetch(
                `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${encodeURIComponent(
                    SHEET_NAME
                )}?key=${API_KEY}`
            );
            const data = await response.json();

            setSheetsData([
                {
                    sheetName: SHEET_NAME,
                    headers: data.values?.[0] || [],
                    rows: data.values?.slice(1) || [],
                }
            ]);
        };

        fetchSheetData();
    }, []);


    return (
        <PageWrapper id={"menu"}>
            {/* <PageTitle>Meniu</PageTitle> */}

            {sheetsData.map((sheet, sheetIndex) => (
                <SheetWrapper key={sheetIndex}>
                    {sheet.rows
                        // păstrăm doar rândurile care au ceva în coloana imaginii;
                        // rândurile doar cu text se ascund conform cerinței
                        .filter((row) => hasImageCandidate(row?.[0]))
                        .map((row, rowIndex) => {
                            const imgUrl = normalizeImageUrl(row?.[0]);
                            const validImage = isValidImageUrl(imgUrl);
                            const textLines = (row?.[numberOfColumnTxt] || "")
                                .split(/\r?\n/)
                                .filter(line => line.trim() !== "");
                            return (
                                <Row key={rowIndex} reverse={rowIndex % 2 !== 0}>
                                    {/* IMAGE */}
                                    <ImageWrapper>
                                        <Image
                                            src={validImage ? imgUrl : noImage}
                                            alt={textLines?.[0] || ""}
                                            loading="lazy"
                                            onError={(e) => (e.currentTarget.src = noImage)}
                                        />
                                    </ImageWrapper>

                                    {/* TEXT */}
                                    <TextCard>
                                        <TextLines>
                                            {textLines.map((line, i) => (
                                                <TextLine key={i}>{parseLine(line)}</TextLine>
                                            ))}
                                        </TextLines>
                                    </TextCard>
                                </Row>
                            );
                        })}
                </SheetWrapper>
            ))}
        </PageWrapper>
    );
}

export default Content;
